module.exports = __webpack_public_path__ + "static/img/eicad_img2.0fb0fa5b.png";